import * as React from "react";
const TeliaTVLogo = ({ title = "Telia TV", className }) => {
  return /* @__PURE__ */ React.createElement("svg", { width: "202", height: "56", xmlns: "http://www.w3.org/2000/svg", className, viewBox: "0 0 202 56", role: "img" }, /* @__PURE__ */ React.createElement("title", null, title), /* @__PURE__ */ React.createElement("path", { className: "logo__path", d: "M84.9687 19.7699H76.3279V44.1112H70.8455V19.7699H62.1226V15.0342H84.9687V19.7699Z", fill: "#990AE3" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "logo__path",
      d: "M101.418 35.181H86.0906C86.6301 38.2554 88.8328 40.2901 91.657 40.2901C93.7757 40.2901 95.4781 39.3343 96.5178 37.757L100.589 40.2079C98.5114 42.9911 95.1066 44.6525 91.6589 44.6525C85.9693 44.6525 81.0264 40.1258 81.0264 33.6447C81.0264 27.1637 85.9282 22.6799 91.4106 22.6799C98.5936 22.6781 102.123 28.4106 101.418 35.181ZM86.2568 31.317H96.4749C95.8514 28.6178 94.108 26.9135 91.4069 26.9135C88.8738 26.9154 86.9624 28.6589 86.2568 31.317Z",
      fill: "#990AE3"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "logo__path",
      d: "M112.3 44.1934C111.511 44.3595 110.68 44.4006 109.933 44.4006C106.278 44.4006 104.658 42.6552 104.658 39.1254V15.0342H109.767V38.4198C109.767 40.2062 110.848 40.4544 112.3 40.2883V44.1934Z",
      fill: "#990AE3"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "logo__path",
      d: "M114.958 17.444C114.958 15.8237 116.372 14.4946 117.99 14.4946C119.569 14.4946 120.98 15.8237 120.98 17.444C120.98 19.0642 119.567 20.3933 117.99 20.3933C116.372 20.3933 114.958 19.0642 114.958 17.444ZM115.416 44.1112V23.3426H120.525V44.1112H115.416Z",
      fill: "#990AE3"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "logo__path",
      d: "M141.999 29.4074V44.1112H137.222V41.7013C135.602 43.82 133.026 44.6096 130.866 44.6096C126.381 44.6096 123.723 41.7853 123.723 38.2536C123.723 34.2253 128.251 30.9437 133.775 30.9437C134.855 30.9437 136.018 31.0277 137.056 31.36V29.9898C137.056 27.9122 135.852 26.8333 133.401 26.8333C131.201 26.8333 129.248 27.9552 128.044 29.4093L124.43 26.7512C126.465 24.3842 129.955 22.7229 133.485 22.7229C139.009 22.7192 141.999 25.129 141.999 29.4074ZM137.056 36.0938V35.1792C136.226 34.888 135.354 34.8058 134.273 34.8058C130.534 34.8058 128.625 36.301 128.625 38.1285C128.625 39.6237 129.913 40.5794 131.865 40.5794C134.439 40.5794 137.056 39.0432 137.056 36.0938Z",
      fill: "#990AE3"
    }
  ), /* @__PURE__ */ React.createElement("path", { className: "logo__path", d: "M175.08 15.4114H153.514V18.4454H162.534V44.1114H166.06V18.4454H175.08V15.4114Z", fill: "#990AE3" }), /* @__PURE__ */ React.createElement("path", { className: "logo__path", d: "M189.331 40.0114L180.516 15.4114H176.744L187.404 44.1114H191.135L202 15.4114H198.351L189.331 40.0114Z", fill: "#990AE3" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "logo__path",
      d: "M37.919 0C20.8949 0 0.000427246 11.2 0.000427246 25.4895C0.000427246 36.6895 15.0919 56 26.313 56C37.5341 56 53.3981 38.2342 53.3981 13.5184C53.3981 3.47631 46.0448 0 37.919 0ZM44.1148 31.3205L19.9768 45.231C17.5473 46.6303 14.5119 44.8805 14.5119 42.0818V14.2609C14.5119 11.4622 17.5473 9.71238 19.9768 11.1117L44.1148 25.0222C46.5442 26.4215 46.5442 29.9212 44.1148 31.3205Z",
      fill: "#990AE3"
    }
  ));
};
export {
  TeliaTVLogo
};
